import { action } from 'satcheljs';

export const fetchAndValidateDomain = action('fetchAndValidateDomain');
